import { TalentFileRepository } from 'packages/talent/TalentFileRepository';
import { CancelablePromise } from 'packages/core/CancelablePromise';
var TalentFileService = /** @class */ (function () {
    function TalentFileService() {
        this.fileRepository = new TalentFileRepository();
        this.currentTalentId = null;
        this.talentFiles = [];
        this.total = null;
        if (!TalentFileService.instance) {
            TalentFileService.instance = this;
        }
        return TalentFileService.instance;
    }
    TalentFileService.prototype.allFilesForTalent = function (talentId, force, jobId) {
        var _this = this;
        if (!force && this.currentTalentId === talentId) {
            return new CancelablePromise(function (resolve) { return resolve(_this.talentFiles); });
        }
        return this.fileRepository.allFilesForTalent(talentId, jobId)
            .then(function (files) {
            _this.currentTalentId = talentId;
            _this.total = files.length;
            return _this.talentFiles = files;
        });
    };
    TalentFileService.instance = null;
    return TalentFileService;
}());
export { TalentFileService };
